// src/pages/ClinicalDataCollector/components/output/sections/HypertensionSection.jsx

import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Divider,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import GroupIcon from '@mui/icons-material/Group';

const HypertensionSection = ({ data }) => {
  // Si ni siquiera hay objeto, no renderizamos nada
  if (!data) return null;

  // Normalizamos todos los arreglos para evitar .map sobre null/undefined
  const bpDistribution = Array.isArray(data.bpDistribution)
    ? data.bpDistribution
    : [];

  const nntList = Array.isArray(data.nnt)
    ? data.nnt
    : [];

  const keyRecommendations = Array.isArray(data.keyRecommendations)
    ? data.keyRecommendations
    : [];

  const sharedDecisionPoints = Array.isArray(data.sharedDecisionPoints)
    ? data.sharedDecisionPoints
    : [];

  return (
    <Card elevation={3} sx={{ borderRadius: 2, mb: 4 }}>
      <CardHeader
        title="Hypertension Section"
        titleTypographyProps={{ variant: 'h5', align: 'center' }}
        action={<FavoriteIcon fontSize="large" color="error" />}
      />
      <Divider />
      <CardContent>
        {/* BP Reading Distribution */}
        <Typography variant="h6" sx={{ mb: 1 }}>
          BP Reading Distribution
        </Typography>
        <Table size="small" sx={{ mb: 3 }}>
          <TableHead>
            <TableRow>
              <TableCell>Category</TableCell>
              <TableCell># of Readings</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bpDistribution.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell>{row.category}</TableCell>
                <TableCell>{row.count}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {/* NNT */}
        <Typography variant="h6" sx={{ mb: 1 }}>
          NNT for Prevention
        </Typography>
        <Table size="small" sx={{ mb: 3 }}>
          <TableHead>
            <TableRow>
              <TableCell>Outcome</TableCell>
              <TableCell>NNT</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {nntList.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell>{row.outcome}</TableCell>
                <TableCell>{row.value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {/* Key Recommendations */}
        <Typography
          variant="h6"
          sx={{ display: 'flex', alignItems: 'center', mb: 1 }}
        >
          <PlaylistAddCheckIcon sx={{ mr: 1 }} /> Key Recommendations
        </Typography>
        <List dense sx={{ mb: 3 }}>
          {keyRecommendations.map((rec, idx) => (
            <ListItem key={idx} disablePadding>
              <ListItemIcon>
                <PlaylistAddCheckIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={rec} />
            </ListItem>
          ))}
        </List>

        {/* Shared Decision-Making Points */}
        <Typography
          variant="h6"
          sx={{ display: 'flex', alignItems: 'center', mb: 1 }}
        >
          <GroupIcon sx={{ mr: 1 }} /> Shared Decision-Making Points
        </Typography>
        <List dense>
          {sharedDecisionPoints.map((point, idx) => (
            <ListItem key={idx} disablePadding>
              <ListItemIcon>
                <GroupIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={point} />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default HypertensionSection;
